import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonModule } from '@components/button';
import { ExperimentService } from '@services/experiment/experiment.service';

@Component({
  selector: 'confirm-cod-order-bottom-sheet',
  templateUrl: './confirm-cod-order.component.html',
  imports: [ButtonModule, CommonModule],
})
export class ConfirmCodOrderComponent implements OnInit {
  acqRebranding2025: boolean = false;
  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<ConfirmCodOrderComponent>,
    private readonly experimentService: ExperimentService,
    // eslint-disable-next-line new-cap
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { orderSp: number, payOnline: () => void, confirmCodOrder: () => void },
  ) {}

  ngOnInit(): void {
    this.acqRebranding2025 = this.experimentService.acqRebranding2025;
  }

  confirmOrder(): void {
    this.data.confirmCodOrder();
    this.bottomSheetRef.dismiss();
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  payOnline(): void {
    this.data.payOnline();
    this.bottomSheetRef.dismiss();
  }
}
